import { useSearchParams } from "react-router-dom";
import { ALL, NONE } from "@miplatform/constants";
import { BidFilter } from "../types";

export const useBidSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setFiltersInSearchParams = (filters: BidFilter) => {
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== ALL && value !== NONE) {
        searchParams.set(key, value as string);
      } else {
        searchParams.delete(key);
      }
    });
    setSearchParams(searchParams);
  };

  const getFiltersFromSearchParams = (): BidFilter | null => {
    if (searchParams.size === 0) {
      return null;
    }

    return {
      groupBy: searchParams.get("groupBy") || NONE,
      sortBy: searchParams.get("sortBy") || NONE,
      builderId: searchParams.get("builderId") || ALL,
      communityId: searchParams.get("communityId") || ALL,
      seriesGroupId: searchParams.get("seriesGroupId") || ALL,
      seriesId: searchParams.get("seriesId") || ALL,
      assigneeId: searchParams.get("assigneeId") || ALL,
      planStatus: searchParams.get("planStatus") || ALL,
    };
  };

  const buildListUrlWithSearchParams = (
    filters: BidFilter,
    search?: string
  ): string => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== ALL && value !== NONE) {
        params.set(key, value as string);
      }
    });
    if (search && search.trim().length > 0) {
      params.set("search", search.trim());
    }
    const encodedParams = params.toString();

    return encodedParams
      ? `/estimating/bids/list/search?${encodedParams}`
      : `/estimating/bids/list/search`;
  };

  const clearSearchParams = () => {
    setSearchParams(new URLSearchParams());
  };

  return {
    searchParams,
    setSearchParams,
    setFiltersInSearchParams,
    getFiltersFromSearchParams,
    buildListUrlWithSearchParams,
    clearSearchParams,
  };
};
